import * as React from 'react'
import autobind from 'autobind-decorator'
import {connect} from 'redux-scaffolding-ts'
import {useTranslation, withTranslation, WithTranslation} from 'react-i18next'
import {Button, Checkbox, Form, Icon, Select} from 'antd';
import {ProjectTasksDropdownStore} from 'src/stores/projecttasks-store'
import {ItemReference, QueryResult} from 'src/core/stores/dataStore'
import ProjectTaskFormBody from 'src/components/task-new';
import ProjectTaskFormBodyUser from 'src/components/task-new-user';
import {ProjectsStore} from 'src/stores/projects-store'
import {useDispatch, useSelector} from "react-redux";
import {ApplicationState} from "../stores/reducers";
import {TimesheetsStore} from "../stores/timesheets-store";
import {CheckboxChangeEvent} from "antd/es/checkbox";
import {onSuccessAddTask} from "../stores/actions/TimeSheet";

const { Option } = Select;
interface ProjectTaskEditorProps extends WithTranslation {
    companyId: string,
    projectId?: string,
    employeeId?: string,
    disabled?: boolean,
    value?: number,
    onChange?: (value: number) => void,
    placeholder?: string,
    nullable?: boolean,
    minWidth?: number,
    includeProjectName?: boolean,
    canAddNewProjectsTask?: boolean,
    multiple?: boolean,
    excludeAssignments?: boolean,
    fromDate?: number,
    toDate?: number,
    newProjectTaskCallback?: (id: string) => void,
    toShow?: string[],
    onSave?: () => void,
    companyAllowCir: boolean,
    companyAllowCii: boolean,
    onSelectedOption?: (selectedOption: any) => void,
    showSelectProject?: boolean,
    isOnlyUser?: boolean,
    handleSuccessAddTask?: () => void,
    closeAllModal?: () => void,
    handleToogleAllTaskByProjects?: any,
    successAddTask?: boolean,
    t: any,
    onSelectionChange?: (selectedProjectTaks: TimesheetProjectMode) => void,
}

interface ProjectTaskEditorState {
    projectTaskId: string | number | undefined,
    addNewTask: boolean,
    successAddTask: boolean | undefined,
    selectedProjectId: string,
    selectedProjectTitle: string,
    projects: any[],
    selectAllTasks: boolean,
    projectTasks: [],
}

interface TimesheetProjectMode {
    projectId: string
    projectTitle: string
    projectTasks: ProjectTaskMode[]
}

interface ProjectTaskMode {
    projectTaskId: string
    projectTaskTitle: string
}

@connect(["projectTasksdropdown", ProjectTasksDropdownStore], ['projects', ProjectsStore])
class ProjectTaskEditor extends React.Component<ProjectTaskEditorProps, ProjectTaskEditorState> {

    private get projectTasksStore() {
        return (this.props as any).projectTasksdropdown as ProjectTasksDropdownStore;
    }

    private get projectsStore() {
        return (this.props as any).projects as ProjectsStore;
    }

    componentDidMount() {
        this.getProjects('')
    }
    constructor(props: ProjectTaskEditorProps) {
        super(props);
        this.state = {
            projectTaskId: props.value,
            addNewTask: false,
            successAddTask: props.successAddTask,
            selectedProjectId: '',
            selectedProjectTitle: '',
            projectTasks: [],
            projects: [],
            selectAllTasks: false,
        }
        if (props.projectId)
            this.projectTasksStore.changeUrlByProject(props.companyId, props.projectId);
    }

    static getDerivedStateFromProps(nextProps: ProjectTaskEditorProps, prevState: ProjectTaskEditorState) {
        if (nextProps.value !== prevState.projectTaskId) {
            return { projectTaskId: nextProps.value };
        }
        else return null;
    }

    @autobind
    private async sendTaskIdCallback(projectId: string | undefined) {
        if (this.props.companyId && projectId) {
            this.projectTasksStore.changeUrlByProject(this.props.companyId, projectId);
        }

        await this.projectTasksStore.getAllAsync({
                searchQuery: '',
                skip: 0,
                take: 25
            }
        ).then(result => {
            this.setProjectTaskIds(result.items[0].id)
        });
    }

    @autobind
    private setProjectTaskIds(newId: string) {
        if (this.props.newProjectTaskCallback)
            this.props.newProjectTaskCallback(newId)
    }

    @autobind
    private onSave(id: string) {
        this.setProjectTaskIds(id)
        this.props.handleSuccessAddTask && this.props.handleSuccessAddTask()
    }
    @autobind
    private async getProjects(searchQuery: string): Promise<QueryResult<ItemReference>> {
        this.projectsStore.changeUrl(this.props.companyId)

        let result = await this.projectsStore.getProjectEmployeeAsync({
            searchQuery: searchQuery,
            skip: 0,
            take: 100,
            orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
        }, this.props.employeeId);

        let projectsResult = {
            count: result.length,
            items: result.map(o =>{
                return ({
                    id: `${o.projectId}`,
                    title: `${o.projectTitle}`,
                    projectTasks: o.projectTasks
                }) as any
            })  as any[]
        }
        this.setState({projects: projectsResult.items})
        return projectsResult

    }

    getTasksForSelectedProject = (): any[] => {
        const selectedProject = this.state.projects.find(project => project.id === this.state.selectedProjectId);
        return selectedProject ? selectedProject.projectTasks : [];
    }

    handleSelectAllTasksChange = (e: CheckboxChangeEvent) => {
        if (e.target.checked) {
            const selectedProject = this.state.projects.find(project => project.id === this.state.selectedProjectId);
            if (selectedProject) {
                const selectedTasks = selectedProject.projectTasks.map((task: ProjectTaskMode) => {
                    const projectTask: ProjectTaskMode = {
                        projectTaskId: task.projectTaskId,
                        projectTaskTitle: task.projectTaskTitle
                    };
                    return projectTask;
                })
                this.callOnSelectionChange(selectedTasks);
            }
        } 

        this.setState({ selectAllTasks: e.target.checked });
    };

    handleTaskSelectionChange = (value: any) => {
        let tasks: ProjectTaskMode[] = [];

        if (typeof value === 'string') {
            tasks.push(JSON.parse(value));
        } else if (Array.isArray(value) && value?.length > 0) {
            tasks = value.map(jsonString => JSON.parse(jsonString));
        }

        this.callOnSelectionChange(tasks);
    };

    callOnSelectionChange = (selectedTasks: ProjectTaskMode[]) => {
        const timesheetProject: TimesheetProjectMode = {
            projectId: this.state.selectedProjectId,
            projectTitle: this.state.selectedProjectTitle,
            projectTasks: selectedTasks
        };
        this.props.onSelectionChange && this.props.onSelectionChange(timesheetProject);
    };

    handleChange = (value: any,) => {
        let selectedProject = typeof value === 'string' ? JSON.parse(value) : undefined;
        if (this.props.onChange) {
            this.props.onChange(selectedProject && selectedProject.id ? selectedProject.id : undefined);
        }
        this.setState({
            selectedProjectId: selectedProject && selectedProject.id ? selectedProject.id : undefined,
            selectedProjectTitle: selectedProject && selectedProject.title ? selectedProject.title : undefined
        });
    };

    renderSelectionInput() {
        return (
            <>
                <Select
                    style={{ marginTop: 5 }}
                    onSearch={(value) => this.projectTasksStore.getAllAsync({ searchQuery: value, skip: 0, take: 25 })}
                    showSearch
                    suffixIcon={<Icon type="project" />}
                    placeholder={this.props.t("Select a project")}
                    onChange={this.handleChange}
                    allowClear={true}
                    filterOption={(inputValue, option) =>
                        typeof option.props.children === 'string' && option.props.children.toLowerCase().includes(inputValue.toLowerCase())
                    }
                >
                    {this.state.projects.map(project => (
                        <Option key={project.id} value={JSON.stringify({ id: project.id, title: project.title })}>{project.title}</Option>
                    ))}
                </Select>
            </>
        );
    }

    renderNewTaskButton() {
        return (
            this.props.canAddNewProjectsTask &&
            <a onClick={() => this.setState({addNewTask: true})}>
                <Button disabled={this.props.disabled} style={{padding: "0px 8px", marginTop: '10px'}}>
                    <Icon type="plus"/>
                </Button> {this.props.t("New task")}
            </a>
        );
    }
    renderSelectionInputTask() {
        return (<>
            <Select
                style={{marginTop: 5}}
                showSearch
                placeholder={this.props.t("Select a task")}
                disabled={!this.state.selectedProjectId || this.state.selectAllTasks}
                mode="multiple"
                filterOption={(inputValue, option) =>
                    typeof option.props.children === 'string' && option.props.children.toLowerCase().includes(inputValue.toLowerCase())
                }
                onChange={(task: ProjectTaskMode) => this.handleTaskSelectionChange(task)}
                allowClear={true}
            >
                {this.getTasksForSelectedProject().map(task => (
                    <Option key={task.projectTaskId} value={JSON.stringify(task)}>{task.projectTaskTitle}</Option>
                ))}
            </Select>
        </>

        );
    }

    renderAddNewTaskComponent() {
        const Component = this.props.isOnlyUser ? ProjectTaskFormBodyUser : ProjectTaskFormBody;
        return this.state.addNewTask && (
            <Component
                companyAllowCir={this.props.companyAllowCir}
                companyAllowCii={this.props.companyAllowCii}
                disabled={this.props.disabled}
                companyId={this.props.companyId}
                onSave={(id) => { this.onSave(id) }}
                onClose={() => {
                    this.props.closeAllModal && this.props.closeAllModal();
                    this.setState({addNewTask: false})
                }}
                newProjectCallback={id => { this.sendTaskIdCallback(id); }}
                isOnlyUser={this.props.isOnlyUser}
            />
        );
    }

    public render() {
        return (
            <Form onKeyUp={(e) => { if (e.keyCode === 13 && this.props.onSave) { this.props.onSave(); } }}>
                { !this.props.successAddTask && this.props.showSelectProject && (
                    <>
                        {this.renderSelectionInput()}
                        {this.state.selectedProjectId &&
                            <>
                            <Checkbox
                            style={{marginTop: 5, width: '100%'}}
                                checked={this.state.selectAllTasks}
                                onChange={this.handleSelectAllTasksChange}
                            >
                                {this.props.t("Select all tasks of projects")}
                            </Checkbox>                                                
                            {this.state.selectAllTasks ? null : this.renderSelectionInputTask()}
                            </>
                        }
                    </>
                ) }
                { this.renderNewTaskButton() }
                { this.renderAddNewTaskComponent() }
            </Form>
        );
    }
}
export const WrapperProjectTaskEditor = (props: any) => {
    const dispatch = useDispatch();
    const successAddTask = useSelector((state: ApplicationState) => state.timeSheet.successAddTask);
    const { t } = useTranslation();
    const handleSuccessAddTask = () => dispatch(onSuccessAddTask())

    return (
        <ProjectTaskEditor
            handleSuccessAddTask={handleSuccessAddTask}
            successAddTask={successAddTask}
            t={t}
            {...props}
        />
    ) 
}

export default withTranslation()(ProjectTaskEditor)